@use "sass:map";
@use "sass:math";

:host {
  display: flex;
  grid-column: span var(--anchor-grid-column) / span var(--anchor-grid-column);
}

$columnSpecs: (
  xs: (
    alias: 'column',
    size: 4,
    maxWidth: '599px',
  ),
  sm: (
    alias: 'sm-column',
    size: 8,
    minWidth: '600px',
    maxWidth: '904px',
  ),
  md: (
    alias: 'md-column',
    size: 12,
    minWidth: '905px',
    maxWidth: '1239px',
  ),
  lg: (
    alias: 'lg-column',
    size: 12,
    minWidth: '1240px',
    maxWidth: '1439px',
  ),
  xl: (
    alias: 'xl-column',
    size: 12,
    minWidth: '1440px',
  ),
);

/**
 * This SCSS code dynamically generates CSS custom properties for grid columns based on breakpoints and sizes.
 * 
 * @param $specs - A map of breakpoints and their specifications.
 * 
 * The code iterates over each breakpoint and its specifications, and for each size within the specification,
 * it generates CSS custom properties (--anchor-grid-column) for the host element based on the current breakpoint.
 * 
 * The generated CSS custom properties are applied conditionally based on the media queries for different breakpoints:
 * - For 'xs' breakpoint, it applies the property for max-width media query.
 * - For 'xl' breakpoint, it applies the property for min-width media query.
 * - For other breakpoints, it applies the property for both min-width and max-width media queries.
 * 
 * The code also handles cases where the host element has multiple breakpoint attributes, ensuring that the custom
 * property is only applied when the element does not have conflicting breakpoint attributes.
 */
@each $breakpoint, $spec in $columnSpecs {
  // Iterate over each size within the specification
  @for $i from 1 through map.get($spec, 'size') {
    @if $breakpoint == xs {
      @each $key, $respec in $columnSpecs {
        :host([#{map.get($spec, 'alias') + '="' + $i + '"'}]:not([#{map.get($respec, 'alias')}])) {
          @if $key == xs {
          } // We do nothing if it's xs
          @else if $key == xl {
            @media (min-width: #{map.get($respec, 'minWidth')}) {
              --anchor-grid-column: #{$i * (math.div(map.get($respec, 'size'), map.get($spec, 'size')))};
            }
          } @else {
            @media (min-width: #{map.get($respec, 'minWidth')}) and (max-width: #{map.get($respec, 'maxWidth')}) {
              --anchor-grid-column: #{$i * (math.div(map.get($respec, 'size'), map.get($spec, 'size')))};
            }
          }
        }
      }
    }
    :host(#{'[' + map.get($spec, 'alias') + '="' + $i + '"]'}) {
      @if $breakpoint == xs {
        @media (max-width: #{map.get($spec, 'maxWidth')}) {
          --anchor-grid-column: #{$i};
        }
      } @else if $breakpoint == xl {
        @media (min-width: #{map.get($spec, 'minWidth')}) {
          --anchor-grid-column: #{$i};
        }
      } @else {
        @media (min-width: #{map.get($spec, 'minWidth')}) and (max-width: #{map.get($spec, 'maxWidth')}) {
          --anchor-grid-column: #{$i};
        }
      }
    }
  }
}

.anchor-c-grid-column {
  width: 100%;
}
